import InputAmount from 'components/InputAmount'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Ether, TokenSymbol } from 'types'
import { PlaceOrderCurrencySelection } from './CurrencySelection'
import { StyledControlInput } from '../../styles/Control'
import { MaxButton } from './MaxButton'

export const QuoteCurrencyInput = memo<{
  currentAmount: Ether
  baseCurrency: TokenSymbol
  quoteCurrency: TokenSymbol
  onChangeAmount: (amount: Ether) => void
  onClickMax: () => void
}>(
  ({
    currentAmount,
    baseCurrency,
    quoteCurrency,
    onChangeAmount,
    onClickMax,
  }) => {
    const { t } = useTranslation()

    return (
      <StyledControlInput>
        <InputAmount
          value={currentAmount}
          placeholder={t('create-order-amount', { defaultValue: 'Amount' })}
          onInput={onChangeAmount}
        />
        <div className="input-border" />
        <MaxButton onClick={onClickMax} />
        <PlaceOrderCurrencySelection
          currentCurrency={quoteCurrency}
          baseCurrency={baseCurrency}
          quoteCurrency={quoteCurrency}
        />
      </StyledControlInput>
    )
  },
)
